module.exports = __webpack_public_path__ + "img/dog-gif.39d32cdf.png";